export const routesEnvanter = [
  {
    path: "/envanter",
    name: "envanter",
    component: () => import("@/views/envanter/index.vue"),
    meta: {
      public: false,
      title: "envanter.Envanter",
      yetki: { k: [1015002] },
    },
  },
  {
    path: "/envanter/:uuid",
    name: "envanter_detay",
    component: () => import("@/views/envanter/profil/index.vue"),
    meta: {
      public: false,
      title: "envanter.Envanter Detay",
      yetki: { k: [1015004] },
    },
  },

  {
    path: "/envanter/hareketler",
    name: "envanter_hareket_listesi",
    component: () => import("@/views/envanter/envanter_hareket/index.vue"),
    meta: {
      public: false,
      title: "envanter.Envanter Hareketleri",
      yetki: { k: [1015002] },
    },
  },
]
